import PropTypes from 'prop-types';
export var OfferAPIDetail = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number])
});
export var Card = PropTypes.shape({
  product: PropTypes.shape({
    name: PropTypes.string,
    institution: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  details: PropTypes.shape({
    image_alt_text: OfferAPIDetail,
    image_source_small: OfferAPIDetail,
    image_source_medium: OfferAPIDetail,
    image_source_large: OfferAPIDetail,
    image_source: OfferAPIDetail,
    slug: OfferAPIDetail,
    legacy_id: OfferAPIDetail,
    is_portrait: OfferAPIDetail
  })
});